import EventEmitter from "./movie_player/event_emitter"

class ProgressButton extends EventEmitter {
  /**
   * @param {HTMLElement} buttonElement
   */
  constructor(buttonElement) {
    super()

    this._buttonElement = buttonElement
    this._progress = null
  }

  init() {
    this._buttonElement.addEventListener('click', (event) => this.trigger('click', this))

    this._progress = new ProgressButton.CircleProgress(this._buttonElement)
    this._progress.init()
    this._progress.hidden = true
  }

  /** @param {number} value normalize required */
  set progress(value) {
    this._progress.value = value
  }

  /**
   * @param {ProgressButton.Icon} value
   */
  set icon(value) {
    const icon = this._buttonElement.querySelector('i')
    icon.className = value
  }

  start() {
    this._progress.hidden = false
    this._buttonElement.disabled = true
  }

  finish() {
    this._progress.hidden = true
    this._progress.value = 0
    this._buttonElement.disabled = false
  }
}

ProgressButton.Icon = {
  Download: 'mdi mdi-24px mdi-download',
  CheckUnderlineCircle: 'mdi mdi-24px mdi-check-underline-circle'
}

ProgressButton.CircleProgress = class {
  /**
   * @param {HTMLElement} container
   */
  constructor(container) {
    this._container = container
    this._svg = null
    this._circle = null
  }

  /** @param {number} value normalize required */
  set value(value) {
    const width = this._container.clientWidth
    const height = this._container.clientHeight
    const radius = Math.min(width, height) / 2
    const length = 2 * Math.PI * radius
    this._circle.setAttribute('stroke-dashoffset', length * (1.0 - value))
  }

  /** @param {boolean} value */
  set hidden(value) {
    if (value) {
      this._svg.style.display = 'none'
    } else {
      this._svg.style.display = 'block'
    }
  }

  init() {
    const width = this._container.clientWidth
    const height = this._container.clientHeight
    const radius = Math.min(width, height) / 2
    const length = 2 * Math.PI * radius

    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
    circle.style.stroke = '#000'
    circle.style.strokeWidth = '2px'
    circle.setAttribute('r', radius)
    circle.setAttribute('cx', `${width / 2}`)
    circle.setAttribute('cy', `${height / 2}`)
    circle.setAttribute('fill', 'none')
    circle.setAttribute('stroke-dasharray', length)
    circle.setAttribute('stroke-dashoffset', length)

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.style.width = width
    svg.style.height = height
    svg.style.overflow = 'visible'
    svg.style.position = 'absolute'
    svg.style.transform = 'rotate(-90deg)'
    svg.setAttribute('viewbox', `0 0 ${width} ${height}`)
    svg.appendChild(circle)

    this._container.appendChild(svg)
    this._svg = svg
    this._circle = circle
  }
}

export default ProgressButton
